export const trashTool = {
  install (toolbox) {
    return toolbox.extend('trash', {
      action () {
        this.$dispatch('DELETE_SELECTED_REGION');
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/annotations-ui/tools/trash.js